export const PROCTORIO = 'proctorio'
export const EXAM_TAKE = 'exam_take'
export const EXAM_END = 'exam_end'
